export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo14-cbd1d60ffc8d4e9c669d3bbf9a1205be.jpg";